/**
 * Main application entry point.
 *
 * 1. We import application wide styles here (handled by webpack loaders).
 * 2. We import `initializer` to initialize for current ENV.
 * 3. We import `React` and `Redux` specific stuff and wire everything up.
 * 4. We render our application into the DOM element with id `app`.
 */

import _html5reset from 'html5-reset/assets/css/reset.css';
import _customStyles from 'styles/index.scss';

import _initializer from 'config/initializer';
import React from 'react';
import { render } from 'react-dom';
import App from 'components/App';

render(<App />, document.getElementById('app'));



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/